// @flow
import { Icon } from 'semantic-ui-react';
import React from 'react';

export const StreamingProjectsIcon = () => <Icon fitted={true} name="youtube square" />;
